let config = {};

// config.baseURL = 'http://localhost:8000/api/v1/';
// config.normalURL = 'http://localhost:8000/';
// config.wsHost = 'localhost';

// config.baseURL = 'http://localhost:8000/api/v1/';
// config.normalURL = 'http://localhost:8000/';
config.wsHost = 'websocket.app-samu.ares-saude.com.br';

//config.baseURL = 'http://localhost:8000/api/v1/';
//config.normalURL = 'http://localhost:8000/';
config.baseURL = 'https://api.samudigitalrio.fs.rj.gov.br/api/v1/';
config.normalURL = 'https://api.samudigitalrio.fs.rj.gov.br/';
// config.wsHost = 'localhost';
config.database = 'CRSAMU_RJ_Rio';

export default config


// WEBPACK FOOTER //
// ./src/config/development.js